if ($(".multicolumn-carousel-slider").length) {
  $(".multicolumn-carousel-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    rtl: true,
    prevArrow:
      '<button type="button" class="slick-prev custom-prev"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 9L17 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 17L1 9L9 1" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-next"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 9L1 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 1L17 9L9 17" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
}

if ($(".carousel-slider").length) {
  $(".carousel-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rtl: true,
    prevArrow:
      '<button type="button" class="slick-prev custom-prev"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 9L17 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 17L1 9L9 1" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-next"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 9L1 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 1L17 9L9 17" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          initialSlide: 2
        },
      },
    ],
  });
}

if ($(".reels-slider").length) {
  var totalSlides = $(".reels-slider .reel-item").length;
  $(".reels-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rtl: true,
    prevArrow:
      '<button type="button" class="slick-prev custom-prev"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 9L17 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 17L1 9L9 1" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-next"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 9L1 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 1L17 9L9 17" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          initialSlide: 6,
        },
      },
    ],
  });
}

if ($(".testimonial-section .testimonial-slider").length) {
  $(".testimonial-section .testimonial-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    rtl: true,
    prevArrow:
      '<button type="button" class="slick-prev custom-prev"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 9L17 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 17L1 9L9 1" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-next"><svg class="tw-w-4 tw-h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16 9L1 9" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 1L17 9L9 17" stroke="#3D3C3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 992, // Tablet breakpoint
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // Mobile breakpoint
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}
